module.exports = __webpack_public_path__ + "img/86.bb60ab9c.jpg";